/*
  Attar de Astana · About page · the markets globe

  A globe drawn by hand on a canvas. No library. Land is a field of dots on a Fibonacci
  sphere, decoded from a bitmap that scripts/build-globe-dots.py writes between the
  markers below. Each market in the section's list is a pin; the home point is a ring
  with an arc to every market.

  The loop runs only while the section is on screen, the tab is visible and something
  is moving: the slow turn, a drag, its inertia, or a glide to a country. Otherwise it
  draws once and waits. Reduced motion: no turn, no inertia, glides are instant, and a
  drag still works because it moves only while the finger moves.

  The list items are the interface. This script gives them tabindex and role at init,
  so with scripts off they are plain text and nothing pretends to be a control.
*/

(() => {
  // @dots-start · generated by scripts/build-globe-dots.py
  const N_SAMPLES = 14000;
  const LAND_DOTS = 3719;
  const DOT_BITS = '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';
  // @dots-end

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const TAU = Math.PI * 2;
  const HALF_PI = Math.PI / 2;

  const PITCH_MAX = 1.1; // radians; the poles never face the reader
  const AUTO_RATE = 0.06; // radians per second
  const AUTO_RAMP_MS = 1000;
  const RESUME_MS = 3000;
  const GLIDE_TAU = 160; // ms, exponential approach, the JS twin of --about-ease
  const DECAY = 0.94; // inertia per 16.7ms
  const V_EPS = 0.0002; // radians per ms
  const TAP_PX = 6;
  const HIT_PX = 24;
  const ARC_SEGMENTS = 32;
  const ARC_LIFT = 0.045;

  /* ----------------------------------------------------------------- data */

  const fibonacci = (i, n, out, o) => {
    const y = 1 - (2 * i + 1) / n;
    const r = Math.sqrt(Math.max(0, 1 - y * y));
    const theta = i * Math.PI * (3 - Math.sqrt(5));
    out[o] = r * Math.cos(theta);
    out[o + 1] = y;
    out[o + 2] = r * Math.sin(theta);
  };

  const decodeDots = () => {
    if (!DOT_BITS) return new Float32Array(0);
    const bytes = atob(DOT_BITS);
    const out = new Float32Array(LAND_DOTS * 3);
    let o = 0;
    for (let i = 0; i < N_SAMPLES && o < out.length; i++) {
      const bit = (bytes.charCodeAt(i >> 3) >> (7 - (i & 7))) & 1;
      if (!bit) continue;
      fibonacci(i, N_SAMPLES, out, o);
      o += 3;
    }
    return out.subarray(0, o);
  };

  const latLngToVec = (lat, lng) => {
    const r = Math.cos(lat);
    return [r * Math.cos(lng), Math.sin(lat), r * Math.sin(lng)];
  };

  /* wrap to (-π, π] */
  const wrap = (a) => {
    a = (a + Math.PI) % TAU;
    if (a < 0) a += TAU;
    return a - Math.PI;
  };

  const rgba = (triplet, alpha) => `rgba(${triplet}, ${alpha})`;

  /* ---------------------------------------------------------------- globe */

  const DOTS = decodeDots();
  const live = new Map();

  const createGlobe = (section) => {
    const stage = section.querySelector('[data-globe-stage]');
    if (!stage) return null;

    const canvas = document.createElement('canvas');
    canvas.className = 'about-markets__canvas';
    canvas.setAttribute('aria-hidden', 'true');
    const ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return null;

    const label = document.createElement('div');
    label.className = 'about-markets__label';
    label.setAttribute('aria-hidden', 'true');
    label.hidden = true;
    stage.prepend(label);
    stage.prepend(canvas);

    const style = getComputedStyle(section);
    const SAGE = style.getPropertyValue('--about-sage').trim() || '98, 126, 125';
    const PAPER = style.getPropertyValue('--about-paper').trim() || '246, 244, 240';
    const showArcs = section.dataset.arcs === 'true';
    let autoAllowed = section.dataset.auto === 'true' && !reduced.matches;

    /* pins from the list */
    const pins = [];
    section.querySelectorAll('[data-globe-pin]').forEach((el) => {
      const lat = parseFloat(el.dataset.lat);
      const lng = parseFloat(el.dataset.lng);
      const ok = Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
      if (!ok) {
        if (window.Shopify && window.Shopify.designMode) {
          console.warn('About markets: no usable coordinates for', el.dataset.name);
        }
        return;
      }
      const latR = (lat * Math.PI) / 180;
      const lngR = (lng * Math.PI) / 180;
      pins.push({
        el,
        name: el.dataset.name || '',
        lat: latR,
        lng: lngR,
        home: el.hasAttribute('data-home'),
        vec: latLngToVec(latR, lngR),
        sx: 0,
        sy: 0,
        z: -1,
      });
    });
    const home = pins.find((p) => p.home) || null;

    /* arcs, in sphere space, once */
    const arcs = [];
    if (showArcs && home) {
      pins.forEach((pin) => {
        if (pin.home) return;
        const a = home.vec;
        const b = pin.vec;
        const dot = clamp(a[0] * b[0] + a[1] * b[1] + a[2] * b[2], -1, 1);
        const omega = Math.acos(dot);
        const so = Math.sin(omega);
        if (so < 1e-6) return;
        const pts = new Float32Array((ARC_SEGMENTS + 1) * 3);
        for (let s = 0; s <= ARC_SEGMENTS; s++) {
          const t = s / ARC_SEGMENTS;
          const wa = Math.sin((1 - t) * omega) / so;
          const wb = Math.sin(t * omega) / so;
          const lift = 1 + ARC_LIFT * 4 * t * (1 - t);
          pts[s * 3] = (wa * a[0] + wb * b[0]) * lift;
          pts[s * 3 + 1] = (wa * a[1] + wb * b[1]) * lift;
          pts[s * 3 + 2] = (wa * a[2] + wb * b[2]) * lift;
        }
        arcs.push(pts);
      });
    }

    /* state */
    const first = home || pins[0];
    let yaw = first ? first.lng - HALF_PI : 0;
    let pitch = first ? clamp(first.lat, -PITCH_MAX, PITCH_MAX) : 0.3;
    let targetYaw = yaw;
    let targetPitch = pitch;
    let gliding = false;
    let vYaw = 0;
    let auto = autoAllowed;
    let autoSince = 0;
    let dragging = false;
    let inView = false;
    let visible = document.visibilityState === 'visible';
    let running = false;
    let raf = 0;
    let last = 0;
    let resumeTimer = 0;
    let holding = 0; // list items hovered or focused
    let active = null; // pin with the label
    let pinned = null; // pin chosen by click or Enter
    let width = 0;
    let R = 0;
    let cx = 0;
    let cy = 0;

    const scratch = new Float32Array(DOTS.length);
    const bucketOf = new Uint8Array(DOTS.length / 3);
    const BUCKET_Z = [0.125, 0.375, 0.625, 0.875];

    /* ------------------------------------------------------------ sizing */

    const resize = () => {
      const rect = stage.getBoundingClientRect();
      const size = Math.floor(Math.min(rect.width, rect.height));
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      width = size;
      if (size <= 0) {
        R = 0;
        return;
      }
      canvas.width = Math.round(size * dpr);
      canvas.height = Math.round(size * dpr);
      canvas.style.width = `${size}px`;
      canvas.style.height = `${size}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      R = size / 2 - 8;
      cx = size / 2;
      cy = size / 2;
    };

    /* -------------------------------------------------------------- draw */

    const draw = () => {
      if (R <= 0) return;
      const cyaw = Math.cos(yaw);
      const syaw = Math.sin(yaw);
      const cp = Math.cos(pitch);
      const sp = Math.sin(pitch);

      ctx.clearRect(0, 0, width, width);

      /* the disc: a faint ground and a darker limb so the sphere reads as a solid */
      ctx.beginPath();
      ctx.arc(cx, cy, R, 0, TAU);
      ctx.fillStyle = rgba(PAPER, 0.03);
      ctx.fill();
      const limb = ctx.createRadialGradient(cx, cy, R * 0.55, cx, cy, R);
      limb.addColorStop(0, 'rgba(0, 0, 0, 0)');
      limb.addColorStop(1, 'rgba(0, 0, 0, 0.32)');
      ctx.fillStyle = limb;
      ctx.fill();
      ctx.strokeStyle = rgba(SAGE, 0.3);
      ctx.lineWidth = 1;
      ctx.stroke();

      /* dots: project once, then four batched fills by depth */
      const count = DOTS.length / 3;
      for (let i = 0, o = 0; i < count; i++, o += 3) {
        const x = DOTS[o];
        const y = DOTS[o + 1];
        const z = DOTS[o + 2];
        const x1 = x * cyaw + z * syaw;
        const z1 = -x * syaw + z * cyaw;
        const y2 = y * cp - z1 * sp;
        const z2 = y * sp + z1 * cp;
        scratch[o] = cx + R * x1;
        scratch[o + 1] = cy - R * y2;
        scratch[o + 2] = z2;
        bucketOf[i] = z2 <= 0 ? 255 : z2 < 0.25 ? 0 : z2 < 0.5 ? 1 : z2 < 0.75 ? 2 : 3;
      }
      const r0 = Math.max(0.9, R * 0.0052);
      for (let b = 0; b < 4; b++) {
        const zb = BUCKET_Z[b];
        const r = r0 * (0.6 + 0.4 * zb);
        ctx.beginPath();
        for (let i = 0, o = 0; i < count; i++, o += 3) {
          if (bucketOf[i] !== b) continue;
          const sx = scratch[o];
          const sy = scratch[o + 1];
          ctx.moveTo(sx + r, sy);
          ctx.arc(sx, sy, r, 0, TAU);
        }
        ctx.fillStyle = rgba(SAGE, 0.22 + 0.78 * zb);
        ctx.fill();
      }

      /* arcs */
      if (arcs.length) {
        ctx.lineWidth = 1;
        for (const pts of arcs) {
          ctx.beginPath();
          let pen = false;
          let sumZ = 0;
          let n = 0;
          for (let s = 0, o = 0; s <= ARC_SEGMENTS; s++, o += 3) {
            const x = pts[o];
            const y = pts[o + 1];
            const z = pts[o + 2];
            const x1 = x * cyaw + z * syaw;
            const z1 = -x * syaw + z * cyaw;
            const y2 = y * cp - z1 * sp;
            const z2 = y * sp + z1 * cp;
            if (z2 <= 0) {
              pen = false;
              continue;
            }
            const sx = cx + R * x1;
            const sy = cy - R * y2;
            if (pen) ctx.lineTo(sx, sy);
            else ctx.moveTo(sx, sy);
            pen = true;
            sumZ += z2;
            n++;
          }
          if (n) {
            ctx.strokeStyle = rgba(SAGE, 0.42 * (sumZ / n));
            ctx.stroke();
          }
        }
      }

      /* pins */
      for (const pin of pins) {
        const [x, y, z] = pin.vec;
        const x1 = x * cyaw + z * syaw;
        const z1 = -x * syaw + z * cyaw;
        const y2 = y * cp - z1 * sp;
        const z2 = y * sp + z1 * cp;
        pin.z = z2;
        if (z2 <= 0) continue;
        pin.sx = cx + R * x1;
        pin.sy = cy - R * y2;
        const a = 0.35 + 0.65 * z2;
        if (pin.home) {
          ctx.beginPath();
          ctx.arc(pin.sx, pin.sy, 2.4, 0, TAU);
          ctx.fillStyle = rgba(PAPER, a);
          ctx.fill();
          ctx.beginPath();
          ctx.arc(pin.sx, pin.sy, 7, 0, TAU);
          ctx.strokeStyle = rgba(PAPER, a);
          ctx.lineWidth = 1;
          ctx.stroke();
        } else {
          ctx.beginPath();
          ctx.arc(pin.sx, pin.sy, 2.8, 0, TAU);
          ctx.fillStyle = rgba(PAPER, a);
          ctx.fill();
        }
        if (pin === active) {
          ctx.beginPath();
          ctx.arc(pin.sx, pin.sy, 11, 0, TAU);
          ctx.strokeStyle = rgba(PAPER, 0.9);
          ctx.lineWidth = 1;
          ctx.stroke();
        }
      }

      /* label, in HTML, moved by transform only */
      if (active && active.z > 0.05) {
        if (label.textContent !== active.name) label.textContent = active.name;
        const flip = active.sx > width * 0.62;
        label.style.transform = `translate3d(${Math.round(active.sx + (flip ? -14 : 14))}px, ${Math.round(active.sy - 12)}px, 0)${flip ? ' translateX(-100%)' : ''}`;
        label.hidden = false;
      } else if (!label.hidden) {
        label.hidden = true;
      }
    };

    /* -------------------------------------------------------------- loop */

    const moving = () => dragging || gliding || Math.abs(vYaw) > V_EPS || auto;
    const gate = () => inView && visible && R > 0 && moving();

    const tick = (now) => {
      const dt = Math.min(50, now - last || 16.7);
      last = now;

      if (!dragging) {
        if (gliding) {
          const k = 1 - Math.exp(-dt / GLIDE_TAU);
          const dy = wrap(targetYaw - yaw);
          const dp = targetPitch - pitch;
          yaw += dy * k;
          pitch += dp * k;
          if (Math.abs(dy) < 0.0015 && Math.abs(dp) < 0.0015) {
            yaw = targetYaw;
            pitch = targetPitch;
            gliding = false;
          }
        } else if (Math.abs(vYaw) > V_EPS) {
          yaw += vYaw * dt;
          vYaw *= Math.pow(DECAY, dt / 16.7);
          if (Math.abs(vYaw) <= V_EPS) vYaw = 0;
        } else if (auto) {
          const ramp = clamp((now - autoSince) / AUTO_RAMP_MS, 0, 1);
          yaw += (AUTO_RATE * ramp * dt) / 1000;
        }
      }
      yaw = wrap(yaw);

      draw();

      if (gate()) {
        raf = requestAnimationFrame(tick);
      } else {
        running = false;
      }
    };

    const wake = () => {
      if (running) return;
      if (!gate()) {
        draw();
        return;
      }
      running = true;
      last = performance.now();
      raf = requestAnimationFrame(tick);
    };

    const stopAuto = () => {
      auto = false;
      clearTimeout(resumeTimer);
    };

    const scheduleResume = () => {
      clearTimeout(resumeTimer);
      if (!autoAllowed) return;
      resumeTimer = setTimeout(() => {
        if (holding || dragging || pinned) return;
        auto = true;
        autoSince = performance.now();
        wake();
      }, RESUME_MS);
    };

    /* ------------------------------------------------------- behaviour */

    const setActive = (pin) => {
      if (active === pin) return;
      if (active) active.el.classList.remove('is-active');
      active = pin;
      if (active) active.el.classList.add('is-active');
      if (!running) draw();
    };

    const centreOn = (pin) => {
      if (!pin) return;
      targetYaw = pin.lng - HALF_PI;
      targetPitch = clamp(pin.lat, -PITCH_MAX, PITCH_MAX);
      vYaw = 0;
      stopAuto();
      if (reduced.matches) {
        yaw = targetYaw;
        pitch = targetPitch;
        gliding = false;
        draw();
      } else {
        gliding = true;
        wake();
      }
    };

    const hitTest = (x, y) => {
      let best = null;
      let bestD = HIT_PX * HIT_PX;
      for (const pin of pins) {
        if (pin.z <= 0.1) continue;
        const dx = pin.sx - x;
        const dy = pin.sy - y;
        const d = dx * dx + dy * dy;
        if (d < bestD) {
          bestD = d;
          best = pin;
        }
      }
      return best;
    };

    const controller = new AbortController();
    const { signal } = controller;

    /* pointer */
    let px = 0;
    let py = 0;
    let pt = 0;
    let travel = 0;
    let pointerId = null;

    canvas.addEventListener(
      'pointerdown',
      (event) => {
        if (pointerId !== null) return;
        pointerId = event.pointerId;
        try {
          canvas.setPointerCapture(pointerId);
        } catch (error) {
          /* a synthetic pointer has no capture to take; the drag still works */
        }
        dragging = true;
        section.classList.add('is-dragging');
        stopAuto();
        gliding = false;
        vYaw = 0;
        px = event.clientX;
        py = event.clientY;
        pt = event.timeStamp;
        travel = 0;
        wake();
      },
      { signal }
    );

    canvas.addEventListener(
      'pointermove',
      (event) => {
        if (!dragging) {
          if (event.pointerType === 'mouse' && !pinned) {
            const rect = canvas.getBoundingClientRect();
            const hit = hitTest(event.clientX - rect.left, event.clientY - rect.top);
            if (hit !== active && !holding) setActive(hit);
          }
          return;
        }
        if (event.pointerId !== pointerId) return;
        const dx = event.clientX - px;
        const dy = event.clientY - py;
        const dt = Math.max(1, event.timeStamp - pt);
        px = event.clientX;
        py = event.clientY;
        pt = event.timeStamp;
        travel += Math.abs(dx) + Math.abs(dy);
        const dYaw = dx / R;
        yaw += dYaw;
        pitch = clamp(pitch + dy / R, -PITCH_MAX, PITCH_MAX);
        vYaw = reduced.matches ? 0 : 0.7 * vYaw + 0.3 * (dYaw / dt);
        if (!running) draw();
      },
      { signal }
    );

    const release = (event) => {
      if (event.pointerId !== pointerId) return;
      pointerId = null;
      dragging = false;
      section.classList.remove('is-dragging');
      if (travel < TAP_PX && event.type === 'pointerup') {
        const rect = canvas.getBoundingClientRect();
        const hit = hitTest(event.clientX - rect.left, event.clientY - rect.top);
        pinned = hit && hit === pinned ? null : hit;
        setActive(pinned);
        vYaw = 0;
      } else if (reduced.matches) {
        vYaw = 0;
      }
      scheduleResume();
      wake();
    };
    canvas.addEventListener('pointerup', release, { signal });
    canvas.addEventListener('pointercancel', release, { signal });
    canvas.addEventListener(
      'pointerleave',
      () => {
        if (!dragging && !pinned && !holding) setActive(null);
      },
      { signal }
    );

    /* the list */
    pins.forEach((pin) => {
      const el = pin.el;
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');

      const enter = () => {
        holding++;
        stopAuto();
        setActive(pin);
        centreOn(pin);
      };
      const leave = () => {
        holding = Math.max(0, holding - 1);
        if (!holding) {
          setActive(pinned);
          scheduleResume();
        }
      };
      el.addEventListener('mouseenter', enter, { signal });
      el.addEventListener('mouseleave', leave, { signal });
      el.addEventListener('focus', enter, { signal });
      el.addEventListener('blur', leave, { signal });
      el.addEventListener(
        'click',
        () => {
          pinned = pinned === pin ? null : pin;
          setActive(pinned || pin);
          centreOn(pin);
        },
        { signal }
      );
      el.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          el.click();
        },
        { signal }
      );
    });

    /* observers */
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          inView = entry.isIntersecting;
          if (inView) wake();
        });
      },
      { rootMargin: '10% 0px 10% 0px', threshold: 0 }
    );
    io.observe(section);

    const ro = new ResizeObserver(() => {
      resize();
      wake();
    });
    ro.observe(stage);

    document.addEventListener(
      'visibilitychange',
      () => {
        visible = document.visibilityState === 'visible';
        if (visible) wake();
      },
      { signal }
    );

    reduced.addEventListener(
      'change',
      () => {
        autoAllowed = section.dataset.auto === 'true' && !reduced.matches;
        if (reduced.matches) {
          stopAuto();
          vYaw = 0;
          if (gliding) {
            yaw = targetYaw;
            pitch = targetPitch;
            gliding = false;
          }
          draw();
        } else {
          scheduleResume();
        }
      },
      { signal }
    );

    resize();
    autoSince = performance.now();
    section.classList.add('is-ready');
    wake();

    return {
      centreOn(el) {
        const pin = pins.find((p) => p.el === el || p.el.contains(el));
        if (!pin) return;
        pinned = pin;
        setActive(pin);
        centreOn(pin);
      },
      stop() {
        cancelAnimationFrame(raf);
        running = false;
        clearTimeout(resumeTimer);
        controller.abort();
        io.disconnect();
        ro.disconnect();
        pins.forEach((pin) => {
          pin.el.removeAttribute('tabindex');
          pin.el.removeAttribute('role');
          pin.el.classList.remove('is-active');
        });
        canvas.remove();
        label.remove();
        section.classList.remove('is-ready', 'is-dragging');
      },
    };
  };

  /* --------------------------------------------------------------- wiring */

  const init = (section) => {
    if (!section) return;
    const stale = live.get(section);
    if (stale) {
      stale.stop();
      live.delete(section);
    }
    const globe = createGlobe(section);
    if (globe) live.set(section, globe);
  };

  const sections = (root) => root.querySelectorAll('[data-about-globe]');

  sections(document).forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    sections(event.target).forEach(init);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    sections(event.target).forEach((section) => {
      const globe = live.get(section);
      if (globe) {
        globe.stop();
        live.delete(section);
      }
    });
  });

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('[data-about-globe]');
    if (!section) return;
    const globe = live.get(section);
    if (globe) globe.centreOn(event.target);
  });
})();
